import React, { useRef, useState } from 'react';
import { ArrowRight, RotateCcw } from 'lucide-react';
import { Button } from './ui/button';

export const DemoVideo = ({ src, poster, onContact }) => {
  const ref = useRef(null);
  const [ended, setEnded] = useState(false);

  const replay = () => { setEnded(false); ref.current.currentTime = 0; ref.current.play(); };

  return (
    <div className="relative rounded-2xl border border-cyan-400/20 bg-[#070b15] p-2 shadow-[0_0_60px_rgba(34,211,238,0.12)]">
      <video
        ref={ref}
        data-testid="product-demo-video"
        className="w-full rounded-xl bg-black aspect-video"
        src={src}
        poster={poster}
        controls
        playsInline
        preload="metadata"
        onEnded={() => setEnded(true)}
        onPlay={() => setEnded(false)}
      >
        Your browser does not support video playback.
      </video>
      {ended && (
        <div data-testid="demo-end-prompt" className="mt-2 py-8 md:mt-0 md:py-0 md:absolute md:inset-2 rounded-xl bg-[#0a0e1a]/90 backdrop-blur-md flex flex-col items-center justify-center text-center px-6 animate-in fade-in duration-500">
          <p className="text-xs tracking-[0.3em] text-cyan-400 uppercase">Ready to see it with your data?</p>
          <h3 className="mt-4 text-xl md:text-4xl font-bold text-white max-w-2xl">Get a personalized IronVision AI walkthrough</h3>
          <p className="mt-3 text-sm md:text-base text-slate-400 max-w-xl">Tell us about your RMF and compliance needs and we'll be in touch within 24 hours.</p>
          <div className="mt-6 md:mt-8 flex flex-col sm:flex-row gap-3">
            <Button data-testid="demo-end-request-btn" onClick={onContact} className="bg-cyan-400 hover:bg-cyan-300 text-slate-900 font-semibold h-12 px-7 rounded-md shadow-[0_0_28px_rgba(34,211,238,0.4)]">
              Request a Demo <ArrowRight className="w-4 h-4 ml-1" />
            </Button>
            <Button data-testid="demo-end-replay-btn" onClick={replay} variant="outline" className="h-12 px-6 border-slate-700 bg-transparent text-slate-200 hover:bg-slate-800 hover:text-white">
              <RotateCcw className="w-4 h-4 mr-1" /> Watch again
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default DemoVideo;
